__turbopack_context__.v({
  "container": "aGAHoq_container",
  "excerpt": "aGAHoq_excerpt",
  "title": "aGAHoq_title",
});
